import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { Hero } from "@/components/Hero";
import { Ecosystem } from "@/components/Ecosystem";
import { Services } from "@/components/Services";
import { About } from "@/components/About";
import { CtaBanner } from "@/components/CtaBanner";
import { Contact } from "@/components/Contact";
import { FeaturedListings } from "@/components/listings/ListingCard";
import { EmptyLegs } from "@/components/EmptyLegs";
import { Membership } from "@/components/Membership";
import { JetAccount } from "@/components/JetAccount";
import { PageShell, ScrollManager } from "@/components/PageShell";
import EnquiryPage from "@/pages/EnquiryPage";
import { ListingsPage, ListingDetailPage, EmptyLegsPage } from "@/pages/PublicPages";
import { PaymentSuccessPage, PaymentCancelPage, EmbedConciergePage, PayDepositPage } from "@/pages/MiscPages";
import { AuthProvider, RequireAdmin } from "@/admin/AuthContext";
import AdminLogin, { AdminLayout } from "@/admin/AdminLogin";
import Dashboard from "@/admin/Dashboard";
import LeadsList from "@/admin/LeadsList";
import LeadDetail from "@/admin/LeadDetail";
import { ListingsAdmin, ListingEditor } from "@/admin/ListingsAdmin";
import EmptyLegsAdmin, { MembersAdmin } from "@/admin/EmptyLegsAdmin";
import { JetAccountsAdmin, JetAccountDetail } from "@/admin/JetAccountsAdmin";

const LandingPage = () => (
  <PageShell>
    <Hero />
    <FeaturedListings />
    <Services />
    <Ecosystem />
    <EmptyLegs />
    <Membership />
    <JetAccount />
    <About />
    <CtaBanner />
    <Contact />
  </PageShell>
);

function App() {
  return (
    <div className="App">
      <div className="grain-overlay" aria-hidden="true" />
      <BrowserRouter>
        <ScrollManager />
        <AuthProvider>
          <Routes>
            <Route path="/" element={<LandingPage />} />
            <Route path="/enquire/:type" element={<EnquiryPage />} />
            <Route path="/aircraft-for-sale" element={<ListingsPage category="aircraft" />} />
            <Route path="/yachts" element={<ListingsPage category="yacht" />} />
            <Route path="/listings/:id" element={<ListingDetailPage />} />
            <Route path="/empty-legs" element={<EmptyLegsPage />} />
            <Route path="/payment/success" element={<PaymentSuccessPage />} />
            <Route path="/payment/cancel" element={<PaymentCancelPage />} />
            <Route path="/pay/:id" element={<PayDepositPage />} />
            <Route path="/embed/concierge" element={<EmbedConciergePage />} />
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin" element={<RequireAdmin><AdminLayout /></RequireAdmin>}>
              <Route index element={<Dashboard />} />
              <Route path="leads" element={<LeadsList />} />
              <Route path="leads/:id" element={<LeadDetail />} />
              <Route path="listings" element={<ListingsAdmin />} />
              <Route path="listings/:id" element={<ListingEditor />} />
              <Route path="empty-legs" element={<EmptyLegsAdmin />} />
              <Route path="members" element={<MembersAdmin />} />
              <Route path="jet-accounts" element={<JetAccountsAdmin />} />
              <Route path="jet-accounts/:id" element={<JetAccountDetail />} />
            </Route>
          </Routes>
        </AuthProvider>
      </BrowserRouter>
      <Toaster theme="dark" position="bottom-right" />
    </div>
  );
}

export default App;
